import React from "react";
import { DividerStyles } from "./styles";

const Divider = ({ width }) => {
  return <DividerStyles width={width} />;
};

export { Divider };
